module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"title":"Documentos de Interés","p1":"A continuación presentamos algunos documentos de interés:"},"en":{"title":"Documents of Interest","p1":"Below are some documents of interest:"}}')
  delete Component.options._Ctor
}
